import React, { Component } from 'react'

import Button from "components/CustomButtons/Button.jsx";

import withStyles from "@material-ui/core/styles/withStyles";

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';


import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
import { faCheck } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CircularProgress } from "@material-ui/core";

import Api from 'api/index.js';
import ProvisioningEndpoints from 'api/ProvisioningEndpoints';

class DeleteModal extends Component {

    state = {
        loading: false
    }

    submit = () => {
        Api.post(ProvisioningEndpoints.delete,
            {
                ...this.state,
                product_id: this.props.product_id,
                account_id: this.props.customer_id,
                service_ids: this.props.service_ids
            }
        )
            .then(({ data }) => {
                console.log(data);
                if (this.props.refresh) {
                    this.props.refresh();
                    this.props.close();
                }
            })
            .catch(e => {
                console.error(e);
            });
    }

    render() {

        return (
            <Dialog
                open={this.props.isOpen}
                onClose={this.props.close}
                fullWidth
                maxWidth="sm"
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="form-dialog-title">Delete Selected Prices</DialogTitle>
                <DialogContent>
                    
                </DialogContent>
                <DialogActions>
                    <Button style={{ marginRight: 'auto' }} round onClick={this.props.close} color="rose" simple>
                        Cancel
                    </Button>

                    {
                        this.state.loading ?
                            <CircularProgress color="secondary" style={{ marginBottom: 5, marginRight: 10 }} />
                            :
                            <Button
                                onClick={() => this.submit()}
                                color="rose"
                                round
                            >
                                Save Changes
                                &nbsp;&nbsp;
                                <FontAwesomeIcon icon={faCheck} />
                            </Button>
                    }
                </DialogActions>
            </Dialog>
        );
    }
}

export default withStyles(extendedFormsStyle)(DeleteModal);